<template>
  <div class="home">
    <div class="carousel">
      <el-carousel
        ref="carousel"
        trigger="click"
        class="width100 height100"
        height="100%"
        @click.native="toBanerHref()"
      >
        <el-carousel-item v-for="(item, index) in bannerlist" :key="index">
          <div class="carousel-item">
            <img
              :src="item.ImageUrl"
              alt=""
              srcset=""
              class="width100 height100"
            />
            <h2 class="swiper-text t-center fon-50 w-s-p">{{ item.Name }}</h2>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 在做什么 -->
    <!-- <div class="theme pa-b-40">
      <div class="">
        <div class="title ma-t-40">创作中心服务内容</div>
        <div class="b-blue ma-t-10"></div>
      </div>
      <div class="c-333 t-center ma-tb-20">
        囊括课程、活动、资讯等多种形式的创作内容及服务，搭载试用体系深刻学习创作新技能，拓展创作新思路。
      </div>
      <div
        style="width: 1200px"
        class="flex f-center f-between fon-18 t-center ma-t-20"
      >
        <div class="flex f-center flex-direction">
          <img src="../img/home/s11.png" />
          <div class="ma-t-30">在线课程</div>
          <div class="c-555 ma-t-20 width80 fon-14">
            直播、录播和图文多种形式授课方式
          </div>
        </div>
        <div class="flex f-center flex-direction">
          <img src="../img/home/s12.png" />
          <div class="ma-t-30">行业资讯</div>
          <div class="c-555 ma-t-20 width80 fon-14">
            共享行业报告，深度剖析行业关键词，共同挖掘创作潜力
          </div>
        </div>
        <div class="flex f-center flex-direction">
          <img src="../img/home/s13.png" />
          <div class="ma-t-30">活动中心</div>
          <div class="c-555 ma-t-20 width80 fon-14">
            相关活动资讯，线上线下活动展映
          </div>
        </div>
      </div>
    </div> -->

    <div class="theme pa-b-40 bg-e">
      <div class="">
        <div class="title ma-t-40 t-center">我们做什么？</div>
        <div class="b-blue ma-t-10"></div>
      </div>
      <div class="c-333 t-center ma-tb-20">
        为中国新一代青年创作者进阶专业领域提供平台与方法。<br />展现个人才华,自我提升,职业进阶,寻找伙伴,分享生活,聚集创意的青年创作人互联网社区平台。
      </div>
      <div
        style="width: 1200px"
        class="flex f-center f-between fon-18 t-center ma-t-20"
      >
        <div class="flex f-center flex-direction">
          <img src="../img/home/s21.png" />
          <div class="ma-t-30 c-primary bold">展示基地</div>
          <div class="c-555 ma-t-20 fon-14">
            访谈、影评、线上展映、线下First Time电影人剧场
          </div>
        </div>
        <div class="flex f-center flex-direction">
          <img src="../img/home/s22.png" />
          <div class="ma-t-30 c-primary bold">创作训练营</div>
          <div class="c-555 ma-t-20 fon-14">
            在线课程、在线问答、组建团队、项目众筹
          </div>
        </div>
        <div class="flex f-center flex-direction">
          <img src="../img/home/s23.png" />
          <div class="ma-t-30 c-primary bold">合作与服务</div>
          <div class="c-555 ma-t-20 fon-14">
            评估反馈、策划、监制、定制、NFT数字艺术藏品
          </div>
        </div>
      </div>
    </div>

    <!-- 讲师介绍 -->
    <div class="person">
      <div class="t-center flex f-center flex-direction fon-24 font-bold">
        <div class="fon-24 ma-t-50">职业进阶</div>
        <div class="b-009297 ma-t-10"></div>
      </div>

      <div class="width1200 flex f-around">
        <div>
          <div class="position">
            <img src="../img/home/s31.png" />
            <div class="ma-t-30 fon-18">学习提升</div>
            <div class="ma-t-10 fon-14">通过专业课程系统学习职业知识</div>
          </div>
        </div>
        <div class="position-arrows">
          <img src="../img/home/arrows.png" />
        </div>
        <div>
          <div class="position">
            <img src="../img/home/s32.png" />
            <div class="ma-t-30 fon-18">实战操作</div>
            <div class="ma-t-10 fon-14">全流程参与影片制作的每一个环节</div>
          </div>
        </div>
        <div class="position-arrows">
          <img src="../img/home/arrows.png" />
        </div>
        <div>
          <div class="position">
            <img src="../img/home/s33.png" />
            <div class="ma-t-30 fon-18">传播价值</div>
            <div class="ma-t-10 fon-14">分享您的作品，让更多专业人士看见</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 课程中心 -->

    <!-- <div class="three_box ma-center">
      <div class="t-center flex f-center flex-direction fon-24 font-bold">
        <div class="title">{{ detail.Name }}</div>
        <div class="b-009297 ma-t-10"></div>
      </div>
      <div class="flex f-center f-between ma-t-40">
        <div
          class="boxs ma-t-30"
          v-for="(item, index) in detail.ItemList"
          :key="index"
          @click="toClassdetail(item.CourseId)"
        >
          <img :src="item.CourseImage" class="img_263 b-r-10" />
          <img :src="item.LecturerImage" class="img_30" />
          <div class="ma-t-15 pa-lr-10 flex f-between">
            <span class="fon-12">{{ item.LecturerName }}</span
            ><span class="c-red" v-if="item.SalePrice != 0"
              ><span class="linethrough fon-12 c-8a">￥{{ item.Price }}</span
              >￥{{ item.SalePrice }}</span
            >
            <span class="c-a8" v-else>免费</span>
          </div>
          <div class="t-omit-2 ma-t-15 pa-lr-10 fon-14 weight500">
            {{ item.CourseName }}
          </div>
          <div class="c-71 ma-t-10 pa-lr-10 fon-14">
            {{ item.Duration }}
          </div>
        </div>
      </div>
      <div class="btn_blue ma-center ma-t-60 pointer" @click="moreClass">
        查看更多
      </div>
    </div> -->

    <!-- 活动沙龙 -->
    <!-- <div class="four_box ma-center">
      <div class="t-center flex f-center flex-direction fon-24 font-bold">
        <div class="title">{{ detail2.Name }}</div>
        <div class="b-009297 ma-t-10"></div>
      </div>
      <div class="width1200 height370">
        <div
          class="boxs flex f-center pointer"
          v-for="(item, index) in detail2.ItemList"
          :key="index"
          @click="plays(item.Id)"
        >
          <img :src="item.MainImage" class="img_230 ma-l-10 img_cover" />
          <div class="ma-l-15 ma-r-20 height100 ma-t-20 position">
            <div class="fon-20 font-bold">{{ item.Name }}</div>
            <div class="fon-12 c-41 ma-t-15 t-omit-3">
              {{ item.Summary }}
            </div>
            <div class="fon-12 c-41 time">活动时间：{{ item.StartTime }}</div>
          </div>
        </div>
      </div>
      <div class="btn_blue ma-center ma-t-10 pointer" @click="toActivity">
        查看更多
      </div>
    </div> -->

    <!-- 星辰资讯 -->
    <!-- <div class="three_box ma-center">
      <div class="t-center flex f-center flex-direction fon-24 font-bold">
        <div class="title">{{ detail1.Name }}</div>
        <div class="b-009297 ma-t-10"></div>
      </div>
      <div class="flex f-center f-between ma-t-40">
        <div
          class="boxs ma-t-30 height302 pointer"
          v-for="(item, index) in detail1.ItemList"
          :key="index"
          @click="toNews(item.Id)"
        >
          <img :src="item.Image" class="img_263 img_cover" />

          <div class="t-omit-2 ma-t-10 pa-lr-10 fon-14 weight500">
            {{ item.Name }}
          </div>
          <div class="c-41 ma-t-10 pa-lr-10 fon-12">{{ item.ReleaseTime }}</div>
        </div>
      </div>
      <div class="btn_blue ma-center ma-t-60 pointer" @click="moreNews">
        查看更多
      </div>
    </div> -->
  </div>
</template>
<style lang="scss" scoped>
.height100 {
  height: 100%;
}
.box-wrap {
  width: 30%;
  height: 230px;
  position: relative;
}
.img-bg {
  width: 300px;
  height: auto;
}
.box-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.521);
  color: #fff;
  opacity: 0;
  transition: all 0.3s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-hover-b {
  width: 80%;
  height: 70%;
  border: 1px solid #fff;
  padding: 10px;

  display: flex;
  justify-content: center;
  align-items: center;
}
.box-wrap:hover .box-hover {
  opacity: 1;
}
.lineheight28 {
  line-height: 30px;
}
.width387 {
  width: 387px;
  height: 156px;
}
.img_60 {
  width: 60px;
  height: 60px;
}
.b-r {
  border-right: 1px #eee solid;
}
.b-b {
  border-bottom: 1px #eee solid;
}
.end_box {
  width: 553px;
  height: 232px;
}
.height400 {
  height: 400px !important;
}
.height600 {
  height: 600px !important;
  padding-bottom: 100px;
}
.height700 {
  height: 700px !important;
  padding-bottom: 100px;
}
.bg-e {
  background: #eeeeee !important;
}
.c-555 {
  color: #555;
}
.c-333 {
  color: #333333;
}
.ma-t-50 {
  margin-top: 50px;
}
.img_228 {
  width: 228px;
  height: 305px;
}
.width1200 {
  width: 1200px;

  margin: 90px auto;
}
.person {
  width: 100%;
  height: 539px;
  background-size: cover;
}
.position {
  width: 240px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  img {
    width: 90px;
    height: 90px;
  }
}
.position-arrows {
  width: 240px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  img {
    width: 200px;
    margin-top: 20px;
  }
}

.height370 {
  height: 370px;
}
.width419 {
  width: 419px;
}
.home {
  min-width: 1200px;
  background: #fff;
  min-height: 500px;
  .bim {
    width: 100%;
    height: auto;
    // background-image: url(../img/mdmyy.png);
    // background-size: 100% 100%;
    background-repeat: repeat;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
    }

    .toptexts {
      width: 580px;
      height: 157px;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #000;
      opacity: 0.75;
      .weclome {
        color: #000;
        font-size: 45px;
        font-weight: bold;
        margin-bottom: 30px;
        font-weight: bold;
      }
      .texts {
        line-height: 30px;
        letter-spacing: 3px;
      }
    }
  }
  .carousel {
    width: 100%;
    height: 600px;
    position: relative;
  }
  .swiper {
    width: 100%;
    height: 462px;
    position: relative;
    background-image: url(../img/home/b1.png);
    background-size: cover;
    // background-position: 100% 100%;
    img {
      width: 100%;
      height: 484px;
    }
    .htop {
      width: 1200px;
      margin: 0 auto;
      // position: absolute;
      // top: 17%;
      // left: 50%;
      // transform: translateX(-600px);
    }
    .toptexts {
      width: 100%;
      height: 452px;
      // position: absolute;
      // top: 17%;
      // left: 12%;
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      // font-weight:bold;

      color: #fff;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      text-align: center;
      // line-height: 30px;
      .weclome {
        color: #fff;
        font-size: 16px;
        // font-weight: bold;
        margin-top: 30px;
        // font-weight: bold;
      }
    }
  }
}
.ma-b-0 {
  margin-bottom: 0px !important;
}
.ma-t-70 {
  margin-top: 70px;
}

.btn_green {
  width: 220px;
  height: 40px;
  background: #fb004d;
  border-radius: 20px;
  color: #fff;
}
.btn_white {
  width: 220px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #fb004d;
  border-radius: 20px;
  color: #fb004d;
}

.home .theme {
  background: #fff;
  margin: 0 auto;
  height: 555px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .el-divider__text {
    font-weight: bold;
    color: rgba(15, 119, 191, 1);
  }
}
.home .theme .title {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #000;
}
.b-blue {
  width: 200px;
  height: 3px;
  background: #fb004d;
}
.home .theme .classify {
  width: 362px;
  height: 147px;
  position: relative;
  padding: 30px 5%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.07);
  border-radius: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.home .theme .classify .topic {
  display: flex;
  align-items: center;
  height: 21px;
  line-height: 21px;
  text-align: center;
  font-size: 16px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: rgba(15, 119, 191, 1);
}
.home .theme .classify .topic hr {
  width: 90px;
  height: 1px;
  line-height: 21px;
  color: #fb004d;
  display: inline-block;
  border: 0px;
  background-color: #fb004d;
}
.home .theme .classify .text {
  font-size: 12px;
  height: 48px;
  font-family: MicrosoftYaHei;
  color: rgba(15, 119, 191, 1);
}
.home .theme .classify .img-n {
  position: absolute;
  top: -20px;
  left: 5px;
  width: 53px;
  height: 48px;
}
.home .online {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0px;
  box-sizing: border-box;
  text-align: center;
  .more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    margin: 0 auto;
    cursor: pointer;
    .icons {
      width: 20px;
      height: 20px;
      margin-top: 0;
      border-radius: 50%;
      border: 1px solid #fb004d;
    }
    .more-text {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(15, 119, 191, 1);
      margin-left: 10px;
    }
  }
}
.home .online .online-title {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.home .online .online-type {
  width: 1200px;
  margin: 100px auto 0px auto;
  display: flex;
  justify-content: center;
}
.home .online .online-type .online-type-list {
  width: 25%;
  padding: 5px 0;
  margin-bottom: 70px;
  text-align: center;
  cursor: pointer;
  .type-img {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .type-title {
    margin-top: 25px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
  }
  .type-title:hover {
    color: #000000;
    font-weight: 600;
  }
}
.home .introduce {
  height: 28px;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-bottom: 16px;
}
.home .explain {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .st-title {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
.home .videos {
  width: 268px;
  margin-right: 30px;
  display: flex;
  justify-content: center;
  // padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.home .tool-list {
  width: 350px;
  height: 95px;
  padding: 5px 0;
  margin-bottom: 70px;
  display: flex;
  justify-content: flex-start;
}
.width1140 {
  width: 80%;
  height: 425px;
}
.img_453 {
  width: 453px;
  height: 425px;
}
.c-blue {
  color: #fb004d;
}
.c-primary {
  color: #fb004d;
}
.t-indent {
  // text-indent: 10px;
  line-height: 33px;
}
.b-009297 {
  width: 100px;
  height: 3px;
  background: #fb004d;
}
.three_box {
  width: 1200px;
  height: 700px;
  margin-top: 72px;
  .boxs {
    width: 263px;
    height: 352px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    position: relative;
    .img_263 {
      width: 263px;
      height: 220px;
    }
    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
}
.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}
.four_box {
  width: 100%;
  height: 595px;
  background: #eeeeee;
  padding: 60px 0 0 0;
  .width1200 {
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .boxs {
      width: 549px;
      height: 165px;
      background: #fff;
      border-radius: 5px;
      margin-bottom: 20px;
      .img_230 {
        width: 230px;
        height: 137px;
      }
      .position {
        position: relative;
        .time {
          position: absolute;
          bottom: 30px;
        }
      }
    }
  }
}
.height302 {
  height: 302px !important;
}
.c-41 {
  color: #414141;
}
.carousel-item {
  position: relative;
}
.swiper-text {
  color: #fff;
  position: absolute;
  top: 50%;
  width: 100%;
  margin-top: -50px;
  letter-spacing: 2px;
}
.w-s-p {
  white-space: pre;
}
</style>
<script>
import {
  // Activitys,
  // HomeArticle,
  sign,
  getBanner,
  getuser,
  // CategoryList,
  getIndexs,
} from "../api.js";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      kinds: [], //学习资源种类列表
      newsList: [],
      activityList: [],
      play: false,
      name: "",
      phone: "",
      id: "",
      classList: [],
      detail: {},
      detail1: {},
      detail2: {},
      bannerlist: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("to");
    console.log(to);
    //获取用户token等信息并且缓存
    if (to.query.uToken) {
      let data = JSON.parse(to.query.uToken);
      localStorage.setItem("AccessToken", data.AccessToken);
      localStorage.setItem("RefreshToken", data.RefreshToken);
      localStorage.setItem("AccessTokenTime", data.AccessTokenTime);
      localStorage.setItem("RefreshTokenTime", data.RefreshTokenTime);
      localStorage.setItem("username", data.username);
    }
    getuser().then((res) => {
      if (res.data.Code == 1001) {
        //如果登录过期，则清除token
        // localStorage.clear()
      }
    });

    window.scroll(0, 0);
    // 判断是否从详情页面回来

    next();
  },
  created() {
    // this.getNews();
    // this.getActivitys();
    // this.getClass();
    this.getIndex();
    this.getBannerList();
  },
  methods: {
    //跳转链接
    toBanerHref() {
      let i = this.$refs.carousel.activeIndex;
      let item = this.bannerlist[i];
      console.log(item);
      if (!item.Href) {
        return;
      } else {
        location.href = item.Href;
      }
    },
    //获取首页数据
    getIndex() {
      getIndexs().then((res) => {
        this.detail = res.data.Data[0];
        this.detail1 = res.data.Data[1];
        this.detail2 = res.data.Data[2];
      });
    },

    //获取轮播图
    getBannerList() {
      getBanner().then((res) => {
        this.bannerlist = res.data.Data;
        console.log(this.bannerlist);
        console.log(res);
      });
    },

    toClassdetail(id = 1) {
      this.$router.push({
        path: "/Learn-detail",
        query: { id: id },
      });
    },
    plays(e) {
      this.$router.push({
        path: "/Activity",
        query: {
          id: e,
        },
      });
    },

    //更多课程
    moreClass() {
      this.$router.push({
        name: "Learn",
      });
    },

    //报名提交
    submit() {
      var that = this;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;

      if (this.name == "") {
        this.$message.error("姓名不能为空哦！");
        return;
      }
      if (this.phone.length < 1) {
        this.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(this.phone)) {
        this.$message.error("手机格式不正确！");
        return;
      }

      let token = localStorage.getItem("AccessToken");
      let data = {
        Token: token,
        Name: this.name,
        Phone: this.phone,
        Id: this.id,
      };
      sign(data).then((res) => {
        console.log(res);
        if (res.data.Code == 0) {
          that.$message.success("报名成功");
          that.play = false;
        } else {
          that.$message({
            message: res.data.Message,
            type: "warning",
            center: true,
            customClass: "sps",
          });
        }
      });
    },

    toEnterprise() {
      this.$router.push({
        name: "About",
      });
    },

    //获取 星辰资讯
    // getNews() {
    //   HomeArticle().then((res) => {
    //     if (res.data.Code == 0) {
    //       this.newsList = res.data.Data;
    //     }
    //     console.log(res);
    //   });
    // },

    // getClass() {
    //   let token = localStorage.getItem("AccessToken");
    //   console.log(this.pageIndex);
    //   let data = {
    //     token: token,
    //     source: "web",
    //   };
    //   console.log(data);
    //   CategoryList(data).then((res) => {
    //     if (res.data.Code == 0) {
    //       this.classList = res.data.Data.List.slice(0, 3);
    //     }
    //   });
    // },

    //资讯详情
    toNews(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { id: id },
      });
    },
    // getActivitys() {
    //   let data = {
    //     pagesize: 4,
    //     pageindex: 1,
    //   };
    //   Activitys(data).then((res) => {
    //     console.log(res);
    //     if (res.data.Code == 0) {
    //       this.activityList = res.data.Data.Data;
    //     }
    //   });
    // },
    // 更多资讯
    moreNews() {
      this.$router.push("/Resource");
    },

    //
    toActivity() {
      this.$router.push("/Practice");
    },
  },
};
</script>
